import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
/* LanguagePack::Start
    Logout-Title:ko: "로그인 세션이 무효 처리되어 로그아웃되었습니다",
    Logout-Title:en: "로그인 세션이 무효 처리되어 로그아웃되었습니다",
    Logout-Coutdown:ko: "{{Seconds}}초 뒤, 로그인 페이지로 이동해요",
    Logout-Coutdown:en: "{{Seconds}}초 뒤, 로그인 페이지로 이동해요",
    Logout-Go:ko: "로그인 페이지 이동",
    Logout-Go:en: "로그인 페이지 이동",
LanguagePack::End */
export const Logout = ({ lng }) => {
    const [seconds, setSeconds] = useState(3);
    const navigate = useNavigate();
    const basicHome = () => navigate('/signin');
    useEffect(() => {
        let countdown = 2;
        const timer = setInterval(() => {
            setSeconds(countdown--);
            if (countdown === 0) {
                basicHome();
            }
        }, 1000);
        return () => {
            clearInterval(timer);
        };
    }, []);
    return (_jsxs(_Fragment, { children: ["`\t\t", _jsx("div", { className: "flex w-full h-full items-center justify-center", children: _jsxs("div", { children: [_jsx("div", { className: "", children: lng('Logout-Title') }), _jsx("div", { className: "", children: lng('Logout-Coutdown', { Seconds: seconds }) }), _jsx("a", { onClick: () => basicHome(), className: "flex justify-center pt-10", children: _jsx("button", { type: "button", className: "rounded-md default:ring-2 bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600", children: lng('Logout-Go') }) })] }) })] }));
};
